import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiRadio: Overrides['MuiRadio'] = {
  colorSecondary: {
    color: pallete.primary.dark,
    '&:hover': {
      color: pallete.grey[500],
    },
    '&$checked': {
      color: pallete.primary.dark,
    },
    '&$checked&:hover': {
      color: pallete.grey[500],
    },
  },
};

export default MuiRadio;
